// @vue/component

export default {
  name: 'HelpPageForm',
  data() {
    // TODO: Powinno byc pobierane z bazy
    const categories = ['Ogólne', 'Zmiana komunikatów', 'Modyfikacja placówek/agentów',
      'Zmiana godzin pracy', 'Modyfikacja menu', 'Zgłoszenie awarii', 'Polecam firmę', 'Strefa Promocji'];
    const allowedFileExtensions = ['png', 'jpg', 'jpeg', 'pdf'];
    return {
      form: {
        name: '',
        client: '',
        email: '',
        phoneNumber: '',
        category: '',
        description: '',
        uploadedFiles: [],
      },
      allowedFileExtensions,


      rules: {
        name: [
          { required: true, message: 'To pole jest wymagane.', trigger: 'blur' },
          {
            pattern: /^[AaĄąBbCcĆćDdEeĘęFfGgHhIiJjKkLlŁłMmNnŃńOoÓóPpRrSsŚśTtUuWwYyZzŹźŻż ]+$/,
            message: 'Specjalne znaki nie są dozwolone',
            trigger: 'blur',
          },
        ],
        client: { required: true, message: 'To pole jest wymagane.', trigger: 'blur' },
        email: [
          { required: true, message: 'To pole jest wymagane.', trigger: 'blur' },

        ],
        phoneNumber: [
          {
            pattern: /^[0-9]+$/,
            message: 'Litery nie są dozwolone',
            trigger: 'blur',
          },
          { len: 9, message: 'Numer musi się składać dokładnie z 9 cyfr', trigger: 'blur' },


        ],
        category: {
          required: true, message: 'To pole jest wymagane.', trigger: 'blur',
        },
        description: {
          required: true, message: 'To pole jest wymagane.', trigger: 'blur',
        },
      },

      categories,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters['global/pendingAsyncStoreActions'].includes([
        'form/sendFormData']);
    },
    userData() {
      return this.$store.getters['authorization/user'];
    }
  },
  methods: {
    async submitForm() {
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (!this.form.phoneNumber) this.form.phoneNumber = 'brak';
          const response = await this.$store.dispatch('form/sendFormData', { ...this.form, version: process.env.APP_VERSION });
          if (response && response.status === 200) {
            this.$message({
              message: 'Wiadomość została wysłana.',
              type: 'success',
            });
            this.form.phoneNumber = '';
            this.form.category = '';
            this.form.description = '';
            this.form.uploadedFiles = [];
          } else {
            this.$message({
              message: 'Nie udało się wysłać wiadomości.',
              type: 'error',
            });
          }
        }
      });
    },

    // __validateFileExtenstion(file) {
    //   const fileExtension = hGetPathinfo(file.name, 'PATHINFO_EXTENSION').extension;
    //
    //   if (
    //     !this.allowedFileExtensions.includes(fileExtension)
    //     || !this.allowedFileExtensions.includes(file.type.split('/')[1])
    //   ) {
    //     Notification.error({
    //       title: 'Error',
    //       message: `Nieprawidłowe rozszerzenie pliku. Dozwolone pliku to: ${this.allowedFileExtensions.join(
    //         '/',
    //       )}`,
    //     });
    //     return false;
    //   }
    //
    //   return true;
    // },
    //
    // __validateFileSize(file) {
    //   const maxSize = 1;
    //   if (maxSize * 1024 * 1024 < file.size) {
    //     Notification.error({
    //       title: 'Error',
    //       message: `Plik jest za duży. Maksymalny rozmiar pliku to: ${maxSize}`,
    //     });
    //     return false;
    //   }
    //
    //   return true;
    // },
    //
    // handleBeforeUpload(file) {
    //   return this.__validateFileSize(file) && this.__validateFileExtenstion(file);
    // },
    //
    //
    // handleUploadFile(fileInfo) {
    //   const { file } = fileInfo;
    //   this.form.uploadedFiles.push(file);
    // },

  },


  async created() {
    const userData = this.userData;
    this.userName = `${userData.name[0].toUpperCase()}${userData.name.slice(1)} ${userData.last_name[0].toUpperCase()}${userData.last_name.slice(1)}`;
    this.form.name = this.userName;
    this.form.email = userData.email;
    this.form.client = userData.client.company_name;
    this.form.phoneNumber = userData.phone_number;
  },
};
